export class TrackExpenseDetail {
  organization_id: number;
  map_image: File | null;
  rate_per_km: number;
  total_km: number;
  notes: string;
  is_untracked: boolean;
  routes: string | null;
  amount: number;
  in_accurate_reading: boolean;
  amount_as_per_entry: number;
  amount_as_per_gps: number;
  entered_total_km:number;

  constructor() {
    this.organization_id = 0;
    this.map_image = null;
    this.rate_per_km = 0;
    this.total_km = 0;
    this.notes = null;
    this.is_untracked = false;
    this.routes = null;
    this.amount = null;
    this.in_accurate_reading = false;
  }
}
